export class Paginationmodel {
	page: number;
	totalItems: number;
	results: [];

	constructor() {
	}
}
